import * as yup from "yup";
export const reqforPaymentLineItemSchema = yup.object().shape({
  particulars: yup.string(),
  id: yup.string(),
  itemFrom: yup.string(),
  hsn: yup.string(),
  itemUnit: yup.string(),
  itemQuantity: yup.string(),
  //   invoicenumber: yup.string(),
});

export const ReqForPaymentSchema = yup.object().shape({
  paymentfor: yup.string().required("Required"),
  invoicenumber: yup.string().required("Required"),
  remainingPayment: yup.string(),
  invoiceImg: yup.string().required("Required"),
  paymentImg: yup.string(),
  amount: yup.string().required("Required"),
  vendor: yup.string(),
  paymentType: yup.string().required("Required"),
  poNum: yup.string().when("paymentfor", {
    is: (val) => val !== "SI Kit Payment",
    then: (s) => s.required("Required"),
    otherwise: (s) => s,
  }),

  siKitForClientId: yup.string().when("paymentfor", {
    is: (val) => val === "SI Kit Payment",
    then: (s) => s.required("Required"),
    otherwise: (s) => s,
  }),
  siKitForClient: yup.string().when("paymentfor", {
    is: (val) => val === "SI Kit Payment",
    then: (s) => s.required("Required"),
    otherwise: (s) => s,
  }),
  notes: yup.string(),
  accountholderName: yup.string().required("Required"),
  bankName: yup.string().required("Required"),
  accountNumber: yup.string().required("Required"),
  ifcCode: yup.string().required("Required"),
  // grnNumber: yup.string().required("Required"),
  uploadGRN: yup.string(),
  lineItems: yup.array().of(reqforPaymentLineItemSchema),
});
